import React from 'react';
import Grid from '@mui/material/Grid';
import { connect } from 'react-redux';
import LoadingButton from '@mui/lab/LoadingButton';
import ModalChangeZone from '../ModalChangeZone';
import { ActionChangeZoneHook } from '../../hooks/actionsTicketsHooks/actionChangeZoneHook';
import { postChangeZone } from '_models/redux/post-change-zone/action';
import { cleanChangeZone } from '_models/redux/post-change-zone/clean';
import { getEvents } from '_models/redux/events/action';

const ChangeZone = ({ changeZone, postChangeZone, cleanChangeZone, getEvents }) => {
  const {
    onSubmit,
    handleClickButton,
    handleSelectZone,
    closePopup,
    zoneValue,
    nirNumber,
    loaderButton,
    zones,
    handleSubmit,
    error,
    changeNir,
    modalOpen,
    errorMssge,
    severityAlert,
  } = ActionChangeZoneHook({
    changeZone,
    postChangeZone,
    cleanChangeZone,
    getEvents,
  });

  return (
    <Grid item>
      <LoadingButton
        fullWidth
        size='small'
        onClick={handleClickButton}
        variant='outlined'
        className='button'
      >
        <h4>Cambio de Zona</h4>
      </LoadingButton>
      {modalOpen && (
        <ModalChangeZone
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          closePopup={closePopup}
          alert={alert}
          error={error}
          changeNir={changeNir}
          loaderButton={loaderButton}
          nirNumber={nirNumber}
          handleSelectZone={handleSelectZone}
          zoneValue={zoneValue}
          zones={zones}
          errorMssge={errorMssge}
          severityAlert={severityAlert}
        />
      )}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  changeZone: state.changeZone,
});
const mapDispatchToProps = {
  getEvents,
  postChangeZone,
  cleanChangeZone,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeZone);
